import PropTypes from "prop-types";
import { withTranslation } from "@template/components/translation";
import classnames from "classnames";
import deferredStyles from "../NativeAppBanner/deferred.css";
import styles from "./index.css";

const NameRating = ({ formatTranslation, isNativeBanner, isAccordion }) => {
  return (
    <div
      className={classnames(styles.ratingContainer, {
        [styles.nativeBannerDisplay]: isNativeBanner
      })}
    >
      <span className={styles.ratingText}>
        {formatTranslation("nativeappbanner_the_asos_app_text")}
      </span>
      <div className={styles.rating}>
        <span
          className={classnames(deferredStyles.starsContainer, {
            [deferredStyles.sideNavigationStar]: isAccordion
          })}
          role="img"
          aria-label={formatTranslation("app_download_rating")}
        />
        <span className={styles.ratingSpan} aria-hidden="true">
          {formatTranslation("app_download_count")}
        </span>
      </div>
    </div>
  );
};

NameRating.propTypes = {
  formatTranslation: PropTypes.func,
  className: PropTypes.string,
  isNativeBanner: PropTypes.bool,
  isAccordion: PropTypes.bool
};

export default withTranslation(NameRating);
